import flags from "../../config/flags";

function useFlags() {
  return flags;
}

export default useFlags;
